module.exports = __webpack_public_path__ + "img/feature5.dab1d5b.png";